import { PageHeader } from 'antd';
import React from 'react';

const BasicPageWithHeader: React.FC<{ children: React.ReactNode; extra: React.ReactNode; title: string }> = ({
    children,
    extra,
    title,
    ...props
}) => (
    <PageHeader extra={extra} ghost={false} title={title} {...props}>
        {children}
    </PageHeader>
);

export default BasicPageWithHeader;
